import { SystemStyleObject } from '@chakra-ui/react';

export const footerContainer: SystemStyleObject = {
  bg: 'white',
  borderTop: '1px solid',
  borderColor: 'blackAlpha.100',
  py: 4,
  px: { base: 6, md: 12 },
  mt: 'auto',
};

export const footerLink: SystemStyleObject = {
  cursor: 'pointer',
  fontSize: 'sm',
  fontWeight: 'normal',
  color: 'blackAlpha.500',
  transition: 'color 0.2s ease',
  minW: 'auto',
  h: 'auto',
  _hover: {
    color: 'blackAlpha.800',
    textDecoration: 'underline',
  },
};
